export default __webpack_public_path__ + "static/media/Spinner.c1a9ba6f.svg";